/*
 * 模块: categoryHelpers
 * 职责: 提供分类相关的工具函数（图标、颜色、标签）
 * 依赖: @ant-design/icons, React
 * 导出: getCategoryIcon, getCategoryColor, getCategoryLabel
 * 限制: 文件<280行, 函数<30行
 */

import React from 'react';
import {
  ThunderboltOutlined,
  BookOutlined,
  RocketOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';

export const getCategoryIcon = (category: string): React.ComponentType => {
  switch (category) {
    case 'core':
      return ThunderboltOutlined;
    case 'brand':
      return BookOutlined;
    case 'advanced':
      return RocketOutlined;
    default:
      return InfoCircleOutlined;
  }
};

export const getCategoryColor = (category: string): string => {
  switch (category) {
    case 'core':
      return '#1890ff';
    case 'brand':
      return '#52c41a';
    case 'advanced':
      return '#fa8c16';
    default:
      return '#666';
  }
};

export const getCategoryLabel = (category: string): string => {
  switch (category) {
    case 'core':
      return '核心指标';
    case 'brand':
      return '品牌指标';
    case 'advanced':
      return '高级指标';
    default:
      return '其他指标';
  }
};

